var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0909 2H2.90909C2.40701 2 2 2.40701 2 2.90909V21.0909C2 21.593 2.40701 22 2.90909 22H21.0909C21.593 22 22 21.593 22 21.0909V2.90909C22 2.40701 21.593 2 21.0909 2Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 15.6363L17.1883 10.8246C17.0178 10.6541 16.7866 10.5583 16.5455 10.5583C16.3043 10.5583 16.0731 10.6541 15.9026 10.8246L10.8246 15.9026C10.6542 16.0731 10.4229 16.1689 10.1818 16.1689C9.94071 16.1689 9.70948 16.0731 9.53899 15.9026L7.18828 13.5519C7.01779 13.3814 6.78656 13.2856 6.54545 13.2856C6.30435 13.2856 6.07311 13.3814 5.90263 13.5519L2 17.4545",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.81823 9.27274C9.57134 9.27274 10.1819 8.66222 10.1819 7.90911C10.1819 7.15599 9.57134 6.54547 8.81823 6.54547C8.06511 6.54547 7.45459 7.15599 7.45459 7.90911C7.45459 8.66222 8.06511 9.27274 8.81823 9.27274Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.189e334a8d9cc774066665cbe432b067.svg";
export { ForwardRef as ReactComponent };